/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12Inputs */

const en_onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12 = /** @type {(inputs: Onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once you delete your account, there is no going back. Please be certain.`)
};

const de_onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12 = /** @type {(inputs: Onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du dein Konto löschst, gibt es kein Zurück. Sei dir bitte sicher.`)
};

/**
* | output |
* | --- |
* | "Once you delete your account, there is no going back. Please be certain." |
*
* @param {Onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12 = /** @type {((inputs?: Onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12(inputs)
	return de_onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12(inputs)
});
export { onceyoudeleteyouraccountthereisnogoingbackpleasebecertain12 as "onceYouDeleteYourAccountThereIsNoGoingBackPleaseBeCertain" }